import { render, staticRenderFns } from "./NeoparentNoParentConsent.vue?vue&type=template&id=8f17d158&scoped=true"
import script from "./NeoparentNoParentConsent.vue?vue&type=script&lang=js"
export * from "./NeoparentNoParentConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f17d158",
  null
  
)

export default component.exports